export const isValueEmpty = (value) => {
    return value === null || value === undefined || (typeof value === 'string' && !value.trim());
};
//# sourceMappingURL=validate.js.map